import { SidebarProvider, SidebarTrigger } from '../../Components/ui/sidebar'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import ActionSidebar from './Sidebar'
import { Separator } from '../../Components/ui/separator'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../../Components/ui/breadcrumb'

import { LogOut, Home } from 'lucide-react'
import { Button } from '../../Components/ui/button'

const Index = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const pathSegments = location.pathname.split('/').filter(Boolean).slice(1) // Remove empty segments
  const user =
    JSON.parse(sessionStorage.getItem('actionPlanUser')) &&
    JSON.parse(sessionStorage.getItem('actionPlanUser')).data
  const hideSidebar =
    location.pathname ===
    '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/actionPlan'

  const handleLogout = () => {
    sessionStorage.removeItem('actionPlanUser')
    sessionStorage.removeItem('actionPlanLoginPhone')
    navigate('/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/actionPlan')
  }

  const handleGoHome = () => {
    navigate('/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/addPlan')
  }

  const handleGoToAppHome = () => {
    navigate('/dashboard')
  }

  return (
    <SidebarProvider>
      <div className='flex h-screen w-screen'>
        {!hideSidebar && <ActionSidebar user={user} />}

        <main className='flex-1 overflow-x-hidden'>
          {!hideSidebar && (
            <header className='flex h-auto md:h-16 shrink-0 items-center gap-2 border-b px-2 md:px-4 py-3 md:py-0'>
              <SidebarTrigger className='h-5 w-5 text-gray-400 flex-shrink-0' />
              <Separator orientation='vertical' className='mr-2 h-4 hidden md:block' />

              <Breadcrumb className='flex w-full justify-between items-center flex-wrap md:flex-nowrap gap-2'>
                <BreadcrumbList className='flex-wrap'>
                  {pathSegments.map((segment, index) => {
                    const url = `/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/${pathSegments
                      .slice(0, index + 1)
                      .join('/')}`
                    const isLast = index === pathSegments.length - 1

                    return (
                      <>
                        <BreadcrumbItem key={url} className='text-xs md:text-sm'>
                          {isLast ? (
                            <BreadcrumbPage className='max-w-[150px] md:max-w-none truncate'>
                              {decodeURIComponent(segment)}
                            </BreadcrumbPage>
                          ) : (
                            <Link to={url} className='max-w-[100px] md:max-w-none truncate'>
                              {decodeURIComponent(segment)}
                            </Link>
                          )}
                        </BreadcrumbItem>
                        {!isLast && (
                          <BreadcrumbItem key={`${url}-separator`} className='text-xs md:text-sm'>
                            <BreadcrumbSeparator />
                          </BreadcrumbItem>
                        )}
                      </>
                    )
                  })}
                </BreadcrumbList>
                {user && (
                  <div className='flex items-center space-x-1 md:space-x-2 flex-shrink-0'>
                    <p className='font-semibold text-xs md:text-sm truncate max-w-[120px] md:max-w-none'>
                      {user?.firstName + ' ' + user?.lastName}
                    </p>

                    <span onClick={handleLogout} className='cursor-pointer'>
                      <LogOut className='text-error-500 h-4 md:h-5' />
                    </span>
                  </div>
                )}
              </Breadcrumb>
            </header>
          )}

          <div className='p-2 md:p-4 overflow-x-hidden'>
            <Outlet />
          </div>
        </main>

        {/* Sticky Back to Admin Home Button */}
        {!hideSidebar &&
          location.pathname !==
            '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/addPlan' && (
            <Button
              onClick={handleGoHome}
              className='fixed bottom-6 right-6 h-12 w-12 md:h-14 md:w-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 z-50 p-0'
              title='Back to Admin Home'
            >
              <Home className='h-5 w-5 md:h-6 md:w-6' />
            </Button>
          )}

        {/* Go to App Dashboard Button - Shows on login page */}
        {hideSidebar && (
          <Button
            onClick={handleGoToAppHome}
            className='fixed bottom-6 right-6 h-auto md:h-14 px-4 md:px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 z-50 gap-2 text-sm md:text-base'
            title='Go to App Dashboard'
          >
            <Home className='h-4 w-4 md:h-5 md:w-5' />
            <span>Go to App</span>
          </Button>
        )}
      </div>
    </SidebarProvider>
  )
}

export default Index
